import { render, staticRenderFns } from "./ReliabilityBadge.vue?vue&type=template&id=6da8bba8&scoped=true"
import script from "./ReliabilityBadge.vue?vue&type=script&lang=js"
export * from "./ReliabilityBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da8bba8",
  null
  
)

export default component.exports